import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { auth0 } from '../utils/Auth0'

export default class Login extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);

    this.login = this.login.bind()
  }

  login() {
    auth0.login()
  }

  componentWillMount(){
    //checking the hash param to determine if the login is happening already
    if ( this.props.location.hash === '' ) {
      this.login()
    }
  }

  render() {
    return (
      <div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Login.js